
import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter,
  Output, ViewChild, Input,
} from '@angular/core';
import * as _ from 'lodash';


import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ModalHeaderSearchComponent } from 'shared/modal/modal-header-search/modal-header-search.component';
import { AssetsSearchComponent } from '../assets-search/assets-search.component';
import { AssetsListsSearchComponent } from '../assets-lists-search/assets-lists-search.component';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'add-assets-modal',
  templateUrl: 'add-assets-modal.component.html',
  styleUrls: ['add-assets-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddAssetsModalComponent extends BaseModalComponent {

  @Input() assignedAssets: Array<any> = [];

  @Output() addAssets: EventEmitter<any> = new EventEmitter();

  @ViewChild(AssetsSearchComponent, {static: false})
  assetsSearch: AssetsSearchComponent | void;

  @ViewChild(AssetsListsSearchComponent, {static: false})
  assetsListsSearch: AssetsListsSearchComponent | void;

  @ViewChild(ModalHeaderSearchComponent, {static: false})
  headerSearch: ModalHeaderSearchComponent | void;

  isListsShown: boolean = false;
  private assetsSearchTerm: string = '';
  private listsSearchTerm: string = '';

  get selectedAssets(): Array<any> {
    return _.get(this, 'assetsSearch.selectedRows', []);
  }

  get showActionPanel(): boolean {
    return _.size(this.selectedAssets) > 0 && !this.isListsShown;
  }

  get modalTitle(): string {
    return this.isListsShown ? 'Select a list to add assets from' : 'Add assets';
  }

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  onModalHide() {
    if (this.isListsShown) {
      this.isListsShown = false;
      if (this.headerSearch instanceof ModalHeaderSearchComponent) {
        this.headerSearch.setSearchTerm(this.assetsSearchTerm);
      }
      this.ref.markForCheck();
    } else {
      this.hide();
    }
  }

  onAddClick() {
    this.addAssets.emit(this.selectedAssets);
    this.hide();
  }

  onListsOpen() {
    this.isListsShown = true;
    if (this.headerSearch instanceof ModalHeaderSearchComponent) {
      this.headerSearch.setSearchTerm(this.listsSearchTerm);
    }
    this.ref.markForCheck();
  }

  onClearClick() {
    if (this.isListsShown) {
      this.listsSearchTerm = '';
      if (this.assetsListsSearch instanceof AssetsListsSearchComponent) {
        this.assetsListsSearch.searchByTerm('');
      }
    } else {
      this.assetsSearchTerm = '';
      if (this.assetsSearch instanceof AssetsSearchComponent) {
        this.assetsSearch.searchByTerm('');
      }
    }
  }

  onSearchByTerm(value: string): void {
    if (this.isListsShown) {
      this.listsSearchTerm = value;
      if (this.assetsListsSearch instanceof AssetsListsSearchComponent) {
        this.assetsListsSearch.searchByTerm(value);
      }
    } else {
      this.assetsSearchTerm = value;
      if (this.assetsSearch instanceof AssetsSearchComponent) {
        this.assetsSearch.searchByTerm(value);
      }
    }
  }

  onListSelect(selectedList: any) {
    this.isListsShown = false;
    if (this.headerSearch instanceof ModalHeaderSearchComponent) {
      this.headerSearch.setSearchTerm(this.assetsSearchTerm);
    }
    if (this.assetsSearch instanceof AssetsSearchComponent) {
      this.assetsSearch.searchByList(selectedList);
    }
    this.ref.markForCheck();
  }

  public show(): void {
    super.show();
    if (this.assignedAssets) {
      if (this.assetsSearch instanceof AssetsSearchComponent) {
        this.assetsSearch.setAssignedAssets(this.assignedAssets);
      }
    }
    if (this.assetsListsSearch instanceof AssetsListsSearchComponent) {
      this.assetsListsSearch.fetchLists();
    }
    if (this.assetsSearch instanceof AssetsSearchComponent) {
      this.assetsSearch.startSearch();
    }
  }

  public hide(): void {
    super.hide();
    this.reset();
  }

  private reset(): void {
    if (this.assetsListsSearch instanceof AssetsListsSearchComponent) {
      this.assetsListsSearch.resetData();
    }
    if (this.assetsSearch instanceof AssetsSearchComponent) {
      this.assetsSearch.resetData();
    }
    if (this.headerSearch instanceof ModalHeaderSearchComponent) {
      this.headerSearch.reset();
    }
  }
}
